import type {
    ProductData,
    RelatedVariant
} from "@/lib/content-service/types/ContentServiceProduct"
import { createContext, useContext } from "react"

export type ProductCardContextType = {
    currentVariant: ProductData | RelatedVariant
    setCurrentVariant: React.Dispatch<React.SetStateAction<ProductData | RelatedVariant>>
    thumbnailSelected: number | undefined
    setThumbnailSelected: React.Dispatch<React.SetStateAction<number | undefined>>
    handleChangeVariant: (relatedVariant?: RelatedVariant | undefined) => void
}

export const ProductCardContext = createContext<ProductCardContextType | undefined>(
    undefined
)

export const useProductCardContext = () => {
    const ctx = useContext(ProductCardContext)
    if (!ctx)
        throw new Error(
            "useProductCardContext must be used within ProductCardContext.Provider"
        )
    return ctx
}
